import moment from 'moment';
import * as yup from 'yup';

import { i18nt } from '../../../../../../../root';
import { NSPP_REIMBURSEMENT, NSPP_VALIDATION } from '../../../../../../../services/i18n/namespaces';
import { RBIT_MILEAGE } from '../../EncountersSection/PaymentsSection/reimbursementConstants';

const addressSchema = yup.object({
  type: yup
    .string(i18nt(`${NSPP_REIMBURSEMENT}:validation.chooseAddressType`))
    .required(i18nt(`${NSPP_VALIDATION}:addressTypeIsRequired`)),
  countryId: yup
    .string(i18nt(`${NSPP_REIMBURSEMENT}:validation.chooseCountry`))
    .required(i18nt(`${NSPP_VALIDATION}:countryIsRequired`)),
  regionId: yup
    .string(i18nt(`${NSPP_REIMBURSEMENT}:validation.chooseRegion`))
    .required(i18nt(`${NSPP_VALIDATION}:isRequired`)),
  city: yup
    .string(i18nt(`${NSPP_REIMBURSEMENT}:validation.choseCity`))
    .required(i18nt(`${NSPP_VALIDATION}:cityIsRequired`)),
  address1: yup
    .string(i18nt(`${NSPP_REIMBURSEMENT}:validation.choseAddress1`))
    .required(i18nt(`${NSPP_VALIDATION}:address1Required`)),
  address2: yup.string(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterAddress2`)),
  zipCode: yup
    .string(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterZip`))
    .required(i18nt(`${NSPP_VALIDATION}:zipCodeIsRequired`))
});

export const validationSchema = yup.object({
  note: yup.string(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterNote`)),
  amount: yup
    .number(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterAmount`))
    .positive(i18nt(`${NSPP_REIMBURSEMENT}:validation.amountShouldBePositive`))
    .required(i18nt(`${NSPP_REIMBURSEMENT}:validation.amountIsRequired`)),
  type: yup
    .string(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterType`))
    .required(i18nt(`${NSPP_REIMBURSEMENT}:validation.typeIsRequired`)),
  encounterDate: yup
    .date(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterEncounterDate`))
    .required(i18nt(`${NSPP_REIMBURSEMENT}:validation.encounterDateIsRequired`))
    .typeError(i18nt(`${NSPP_VALIDATION}:invalidDate`))
    .max(moment().endOf('day'), i18nt(`${NSPP_REIMBURSEMENT}:validation.reimbursementFutureVisitSubmitError`)),
  encounter: yup.object().required(i18nt(`${NSPP_REIMBURSEMENT}:validation.encounterIsRequired`)),
  files: yup.array().when('type', {
    is: RBIT_MILEAGE,
    then: schema => schema.min(0),
    otherwise: schema => schema.min(1, i18nt(`${NSPP_REIMBURSEMENT}:validation.filesAreRequired`))
  }),
  mileageAddresses: yup.object({}).when('type', {
    is: RBIT_MILEAGE,
    then: schema =>
      schema.shape({
        travelDate: yup
          .date(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterTravelDate`))
          .required(i18nt(`${NSPP_REIMBURSEMENT}:validation.travelDateIsRequired`)),
        calculatedDistance: yup.number(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterTravelDate`)),
        distance: yup
          .number(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterDistance`))
          .required(i18nt(`${NSPP_REIMBURSEMENT}:validation.distanceIsRequired`)),
        roundTrip: yup.boolean(i18nt(`${NSPP_REIMBURSEMENT}:validation.enterRoundTrip`)),
        startAddress: addressSchema,
        endAddress: addressSchema
      })
  })
});
